"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UserAccount_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAccount = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const sioc_1 = require("../ontologies/sioc");
const Person_1 = require("foaf/lib/shapes/Person");
const Person_2 = require("lincd-schema/lib/shapes/Person");
const Usergroup_1 = require("./Usergroup");
const Space_1 = require("./Space");
const Role_1 = require("./Role");
const dcterms_1 = require("lincd-dcmi/lib/ontologies/dcterms");
const Boolean_1 = require("lincd-xsd/lib/shapes/Boolean");
const XSDDate_1 = require("lincd-xsd/lib/shapes/XSDDate");
const ShapeClass_1 = require("lincd/lib/utils/ShapeClass");
let UserAccount = UserAccount_1 = class UserAccount extends Shape_1.Shape {
    get functions() {
        return this.getAllAs(sioc_1.sioc.has_function, Role_1.Role);
    }
    get scopes() {
        return this.getAllAs(sioc_1.sioc.has_scope, Space_1.Space);
    }
    get email() {
        return this.getValue(sioc_1.sioc.email);
    }
    set email(val) {
        this.overwrite(sioc_1.sioc.email, new models_1.Literal(val));
    }
    get forgotPasswordToken() {
        return this.getValue(sioc_1.sioc.forgot_password_token);
    }
    set forgotPasswordToken(val) {
        this.overwrite(sioc_1.sioc.forgot_password_token, new models_1.Literal(val));
    }
    get id() {
        const id = this.getValue(sioc_1.sioc.id);
        if (isNaN(+id))
            return id;
        return Number(id);
    }
    set id(val) {
        this.overwrite(sioc_1.sioc.id, new models_1.Literal(`${val}`));
    }
    get name() {
        return this.getValue(sioc_1.sioc.name);
    }
    set name(val) {
        this.overwrite(sioc_1.sioc.name, new models_1.Literal(val));
    }
    get avatar() {
        return this.getValue(sioc_1.sioc.avatar);
    }
    set avatar(val) {
        this.overwrite(sioc_1.sioc.avatar, new models_1.Literal(val));
    }
    get accountOf() {
        return (0, ShapeClass_1.getShapeOrSubShape)(this.getOne(sioc_1.sioc.account_of), [
            Person_1.Person,
            Person_2.Person,
        ]);
    }
    set accountOf(val) {
        this.overwrite(sioc_1.sioc.account_of, val.node);
    }
    get accountOfNode() {
        return this.getOne(sioc_1.sioc.account_of);
    }
    get userGroups() {
        return this.getAllAs(sioc_1.sioc.member_of, Usergroup_1.Usergroup);
    }
    get created() {
        return this.getOneAs(dcterms_1.dcterms.created, XSDDate_1.XSDDate);
    }
    set created(val) {
        this.overwrite(dcterms_1.dcterms.created, val.node);
    }
    get owner() {
        return this.getValue(sioc_1.sioc.has_owner);
    }
    set owner(val) {
        this.overwrite(sioc_1.sioc.has_owner, new models_1.Literal(val));
    }
    // static getAccountOf(person: Person) {
    static getAccountOf(person) {
        if (person) {
            let accountNode = person.getOneInverse(sioc_1.sioc.account_of);
            if (accountNode) {
                return (0, ShapeClass_1.getShapeOrSubShape)(accountNode, UserAccount_1);
                // return new this(accountNode);
            }
        }
    }
};
UserAccount.targetClass = sioc_1.sioc.UserAccount;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: sioc_1.sioc.has_function,
        shape: Role_1.Role,
    })
], UserAccount.prototype, "functions", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: sioc_1.sioc.has_scope,
        shape: Space_1.Space,
    })
], UserAccount.prototype, "scopes", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.email,
        required: false,
        maxCount: 1,
    })
], UserAccount.prototype, "email", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.forgot_password_token,
        maxCount: 1,
    })
], UserAccount.prototype, "forgotPasswordToken", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.id,
        required: true,
        maxCount: 1,
    })
], UserAccount.prototype, "id", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.name,
        maxCount: 1,
    })
    /**
     * returns the name associated with the user account, a.k.a. the "user name"
     * this does NOT have to match with the real name of the person whose account this is
     */
], UserAccount.prototype, "name", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.avatar,
        maxCount: 1,
    })
], UserAccount.prototype, "avatar", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.account_of,
        shape: Person_1.Person,
        maxCount: 1,
    })
], UserAccount.prototype, "accountOf", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: dcterms_1.dcterms.created,
        dataType: Boolean_1.Boolean.targetClass,
    })
], UserAccount.prototype, "created", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: sioc_1.sioc.has_owner,
    })
], UserAccount.prototype, "owner", null);
UserAccount = UserAccount_1 = __decorate([
    package_1.linkedShape
], UserAccount);
exports.UserAccount = UserAccount;
//# sourceMappingURL=UserAccount.js.map